import styled from 'styled-components';
import Header from './Header';
import { mediaQueries } from '../shared/config'
import React, {useState, useEffect } from 'react';
import landing from '../images/hhm-horizlanding.gif';
import landing_mobile from '../images/hhm-vertlanding.gif';

const Container = styled.div`
    background-image: url(${props=>props.src});
    background-position: center;
    background-size: cover;
    position: relative;
    height: 97vh;
`

const Credits = styled("div")`
  position: absolute;
  bottom: 30px;
  right: 15px;
  color: black;
  font-size: 12px;
  font-family: 'Poppins', sans-serif;
`;

export default function Landing(props){
    const media = window.matchMedia('(max-width: 750px)');
    const [isMobile, setIsMobile] = useState(media.matches);
    console.log(isMobile);
    media.addEventListener('change', () => {
        if (media.matches !== isMobile) {
          setIsMobile(media.matches);
        }
    });
    return(
        
        <>
            <Header/>
            {isMobile && <Container src={landing_mobile}>
                <Credits>Ashley Kenney, Biona Hui and Shirley Yao/Daily Bruin staff</Credits>
            </Container>}

            {!isMobile && <Container src={landing}>
                <Credits>Ashley Kenney, Biona Hui and Harry Song/Daily Bruin staff</Credits>
            </Container>}
            
        </>
        

    );
}